


























































import { Vue, Component } from "vue-property-decorator";
import VueBase from "@/lib/vuebase";
import ajax from "@/lib/ajax";
import util from "@/lib/util";
import StudentInput from "@/store/models/maintain/studentInput";
@Component({})
export default class StudentPhotoManager extends VueBase {
  loading: boolean = false;
  finished: boolean = false;
  error: boolean = false;
  totalCount: number = 0;
  teacherList: Array<any> = [];
  searchForm: StudentInput = new StudentInput();
  coachName: string = "";
  showPicker: boolean = false;
  carType: string = "";
  idcard: string = "";
  photoUrl: string = "";
  idCardPhotoUrl: string = "";
  carTypes: Array<any> = [
    "A1",
    "A2",
    "A3",
    "B1",
    "B2",
    "C1",
    "C2",
    "C3",
    "C4",
    "C5",
    "D",
    "E",
  ];
  onClickLeft() {
    window.history.go(-1);
  }

  onConfirm(value: any) {
    this.carType = value;
    this.showPicker = false;
  }
  async onSubmit(values: any) {
    console.log("submit", values);
    this.searchForm.carType = this.carType;
    this.searchForm.idCard = this.idcard;

    await ajax
      .get("/Student/GetStudentPhoto", { params: this.searchForm })
      .then((rep) => {
        console.log(rep.data.result);
        console.log(rep.data.result.idCardPhotoUrl);
        this.idCardPhotoUrl = rep.data.result.idCardPhotoUrl;
        this.photoUrl = rep.data.result.photoUrl;
        // this.teacherList.push(...rep.data.result);
        this.finished = true;
      })
      .catch(() => {
        this.error = false;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
